// 📅 StreakDisplay.js
import React from "react";

export default function StreakDisplay({ streak = 0, isTodayActive = false }) {
  const maxDots = 4;
  const todayIndex = (new Date().getDay() + 6) % 7; // mandag = 0

  const getDisplayDots = () => {
    const dots = [];

    console.log("isTodayActive", isTodayActive);

    if (isTodayActive) {
      if (streak < 5) {
        for (let i = 0; i < maxDots; i++) {
          if (i === streak - 1) {
            dots.push({ type: "today", active: isTodayActive });
          } else if (i < streak - 1) {
            dots.push({ type: "filled" });
          } else {
            dots.push({ type: "empty" });
          }
        }
      } else {
        dots.push({ type: "count", count: streak - 1 });
        for (let i = 1; i < maxDots; i++) {
          if (i < maxDots - 2) {
            dots.push({ type: "filled" });
          } else if (i === maxDots - 2) {
            dots.push({ type: "today", active: isTodayActive });
          } else {
            dots.push({ type: "empty" });
          }
        }
      }
    } else {
      console.log("Is anyone there?");
      if (streak > 0 && streak < 3) {
        console.log("making today dot", streak)
        for (let i = 0; i < maxDots; i++) {
          if (i < streak) {
            dots.push({ type: "filled" });
          } else if (i === streak) {
            dots.push({ type: "today" });
          } else {
            dots.push({ type: "empty" });
          }
        }
      } else if (streak >= 3) {
        console.log("making count dot")
        dots.push({ type: "count", count: streak - 1 });
        for (let i = 1; i < maxDots; i++) {
          if (i < maxDots - 1) {
          dots.push({ type: "filled" });
          } else {
            dots.push({ type: "today" });
          }
        }
      } else {
        dots.push({ type: "today" });
        for (let i = 1; i < maxDots; i++) {
          dots.push({ type: "empty" });
        }
      }
    }

    return dots;
  };

  const displayDots = getDisplayDots();

  const letters = ["M", "T", "O", "T", "F", "L", "S"];
  const todayDotIndex = displayDots.findIndex(dot => dot.type === "today");

  const weekdayOffset = todayDotIndex !== -1
    ? todayIndex - (todayDotIndex)
    : todayIndex - 2;  // Hvis der ikke er en "today"-dot, brug første dot

  const dotColor = streak < 7 ? "cyan-400" : "yellow-500";

  return (
    <div className="flex flex-col gap-2 items-center justify-center my-4 py-2 outline outline-1 outline-gray-300 rounded-3xl">
      {/* preload for Tailwind */}
      <div className="bg-cyan-400 bg-yellow-500 text-cyan-400 text-yellow-500 border-cyan-400 border-yellow-500" />
      
        <div className="text-md font-semibold">
            <span> { streak } dags streak </span>
        </div>
        <div className="flex gap-4 mb-2">
            {displayDots.map((dot, index) => {
                const labelIndex = (weekdayOffset + index + 7) % 7;
                return (
                  <div key={index} className="flex flex-col gap-2 items-center">
                    <span
                      className={`text-xs text-gray-500 ${
                        index === 0 && dot.type === "count" ? "invisible" : ""
                      } ${
                        dot.type === "today" ? `font-bold text-${dotColor}` : "font-light"
                      }`}
                    >
                      {letters[labelIndex]}
                    </span>
                    <div
                      className={`
                        w-8 h-8 rounded-full flex items-center justify-center
                        ${dot.type === "filled" || dot.type === "count" || (dot.type === "today" && dot.active) ? `bg-${dotColor}` : ""}
                        ${dot.type === "empty" || (dot.type === "today" && !dot.active) ? "bg-gray-200" : ""}
                        ${dot.type === "today" && !dot.active ? `border-2 border-dashed border-${dotColor}` : ""}
                      `}
                    >
                      {/* Ikon for aktive dage */}
                      {(dot.type === "filled" || (dot.type === "today" && dot.active)) && (
                        <img src="/images/streak_cold_white.png" alt="✓" className="h-5" />
                      )}
                  
                      {/* Tal for "count"-dot */}
                      {dot.type === "count" && <span className="text-white font-bold">+{dot.count -1 }</span>}
                    </div>
                  </div>
                );
            })}
        </div>
    </div>
  );
}